import * as React from "react";
import {VendorWrapper} from "./shared/VendorWrapper";
import {UIStateVendor} from "../data/UIStateVendor";
import {useEffect, useState} from "react";
import {Bundle} from "../data/BundleData";
import {BoothPageContent} from "../components/booth/BoothPageContent";
import {PrimaryLayout} from "../components/widgets/PrimaryLayout";
import {SecondaryBar} from "../components/widgets/SecondaryBar";
import {FullPostModalContainer} from "../components/feed/FeedItem/FullPostModalContainer";
import {observer} from "mobx-react";

export const VendorDashboard = observer(() => {
  const [booth, setBooth] = useState<Bundle|null>(null);
  useEffect(() => {
    if (!booth) return; // skip when it's null/undefined
    // runs whenever booth changes to a new value
    UIStateVendor.setSelectedBooth(booth);
  }, [booth]);

  if(booth) {
    return (
        <>
          <PrimaryLayout className={`bundle ${booth.type}`}>
            <SecondaryBar
                title={booth.fullName}
                subTitle={`${UIStateVendor.settings.COMPANY_NAME} vendor access`}
                buttonAction={()=>{
                  if(1 === UIStateVendor.bundles.length) {
                    UIStateVendor.clearState();
                  } else {
                    setBooth(null);
                  }
                }}
                buttonLabel={'Exit'}
            >
              <button className="logout" onClick={UIStateVendor.clearState}>Sign Out</button>
            </SecondaryBar>
            <BoothPageContent booth={booth} feedData={null} user={null} />
          </PrimaryLayout>
          <FullPostModalContainer />
        </>
    );
  } else {
    return (
      <VendorWrapper>
        <div>
          <h3 className={'level3'}>You have {UIStateVendor.bundles.length} Booths</h3>

          {UIStateVendor.bundles.map((booth) => <div style={{cursor:'pointer', color:'blue', marginBottom: '12px'}} key={booth._id} onClick={()=>{ setBooth(booth); }}>{booth.fullName}&nbsp;&raquo;</div>)}
          <p>
            If you have any questions, or need additional assistance, please contact&nbsp;
            <a href={"mailto:strive@well-concepts.com?subject=Vendor%20System%20Help"}>strive@well-concepts.com</a>
          </p>
          <button className="logout" onClick={UIStateVendor.clearState}>Sign Out</button>
        </div>
      </VendorWrapper>
    );
  }
});